export enum OverwriteCollapseOptions {
  No = 'no',
  Open = 'open',
  Close = 'close',
}
